import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageIssueAttachment } from '@/api/model/interfaces';

export default class DrawingPackageIssueAttachmentOdata extends OdataManager<DrawingPackageIssueAttachment> {}
